import { formatText } from "../TruncateParties";

export const RenderDocuments = ({ documents }) => (
  <div className="tab-content">
    {documents.length === 0 ? (
      <div className="no-data-container">
        <h3 className="no-data-title">No Documents Found</h3>
        <p className="no-data-message">
            No documents have been filed for this case yet.
        </p>
    </div>
    ) : (
      documents.map((doc, index) => (
        <div key={index} className="order-card-doc">
          <div className="doc-div-detail">
            <div>
              <p>
                <strong>Sr No:</strong> {doc.srNo}
              </p>
              <p>
                <strong>Document No:</strong> {doc.documentNo}
              </p>
              <p>
                <strong>Advocate Name:</strong> {formatText(doc.advocateName)}
              </p>
            </div>
            <div>
              <p>
                <strong>Filed By:</strong> {formatText(doc.filedBy)}
              </p>
              <p>
                <strong>Document Filed:</strong> {formatText(doc.documentFiled)}
              </p>
              <p>
                <strong>Date Of Receiving:</strong> {doc.dateOfReceiving}
              </p>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
);